import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { interval, Subscription } from 'rxjs';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { FridgeStorageGateway } from 'src/app/application/gateway/FridgeStorageGateway';
import { PalletStockGateway } from 'src/app/application/gateway/PalletStockGateway';
import { StockAlertGateway } from 'src/app/application/gateway/StockAlertGateway';
import { FridgeStorage } from 'src/app/domain/models/FridgeStorage';
import { CreatePalletStockRequest, FormatPalletStock, PalletStock, PalletStockFilterRequest, PalletStockImport, Stock, StockColumn, UpdatePalletStockRequest } from 'src/app/domain/models/PalletStock';
import { StockAlert } from 'src/app/domain/models/StockAlert';
import { BasicUser } from 'src/app/domain/models/User';
import { ErrorMessageUtil } from 'src/app/ui/util/error-message-util';
import { FileMaxSize } from 'src/app/ui/util/file-max-size';
import { PropertiesPalletStock } from 'src/app/ui/util/pallet-stock-properties';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-user-pallet-stock',
  templateUrl: './user-pallet-stock.component.html',
  styleUrls: ['./user-pallet-stock.component.css'],
  providers: [ConfirmationService]
})

export class UserPalletStockComponent implements OnInit {


  loading: boolean = false;
  loadingAlert: boolean = false;
  loadingPalleStock: boolean = false;
  loadingProcesses: boolean = false;
  isPollingProcesses = false;
  pollingTimeout: any;
  visibleStats: boolean = false;
  formatPalletStock: FormatPalletStock[] = [];
  isEdit: boolean = false;
  headers: string[] = [];
  totalCount = 0;
  pageSize = 5;
  lastPage?: number;
  lastSize?: number;


  pageSizePalletStock: number = 10;
  totalCountPalletStock: number = 0;
  fridgeStorages: FridgeStorage[] = [];

  stockAlerts: StockAlert[] = []
  visibleAlerts: boolean = false;
  visibleProgramFromStock: boolean = false;

  filter: PalletStockFilterRequest = {
    containerFilter: [],
    statusFilter: [],
    speciesFilter: [],
    growerFilter: [],
    speciesSizeFilter: [],
    varietyFilter: [],
    stockId: 0,
    programNameFilter: [],

  }

  stockFormGroup: FormGroup = this._formBuilder.group({
    stockName: ['', Validators.required],
    fridgeStorageId: [null],
    formatPalletStockId: [null, Validators.required]
  })

  fileMaxSize = FileMaxSize.stock;

  profile: BasicUser | undefined;

  stockFile: any
  submitStockFile = false;
  visibleCreateStock: boolean = false;
  visibleCreateFormatPalletStock: boolean = false;
  visiblePalletStock: boolean = false;
  visibleQuarterNameConfig: boolean = false;
  visibleRule: boolean = false;

  stocks: Stock[] = []
  selectStockId: number | undefined
  selectStock: Stock | undefined
  selectedStockName: string | undefined
  selectedStockCreated: string | undefined
  selectedLastFormatId: number | undefined
  palletStock: PalletStock[] = [];
  activeImportProcesses: PalletStockImport[] = [];

  processInterval?: Subscription;

  columns = PropertiesPalletStock;
  stockColumns: StockColumn[] = []

  selectAlertStockId: number | undefined;

  constructor(
    private _router: Router,
    public translate: TranslateService,
    private _palletStockService: PalletStockGateway,
    private _messageService: MessageService,
    private _formBuilder: FormBuilder,
    private _authService: AuthGateway,
    private _fridgeStorageService: FridgeStorageGateway,
    private _confirmationService: ConfirmationService,
    private _stockAlertService: StockAlertGateway

  ){

  }

  manageStock()
  {
    if(this.isEdit)
    {
      this.updateStock()

    }else
    {
      this.createStock()
    }
  }

  createStock()
  {
    this.submitStockFile = true;
    if(this.stockFormGroup.valid)
    {
      this.loading = true;

      let newStock: CreatePalletStockRequest = {
        file: this.stockFile,
        formatPalletStockId: this.stockFormGroup.controls['formatPalletStockId'].value,
        stockName: this.stockFormGroup.controls['stockName'].value,
        fridgeStorageId: this.stockFormGroup.controls['fridgeStorageId'].value
      }

      this._palletStockService.createPalletStock(newStock).subscribe({
        next: (v) => {
            this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.PalletStock.CreatePalletStockSuccess') })
            this.loading = false
            this.visibleCreateStock = false;
            this.getLoadProcesses();
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: ErrorMessageUtil.getResponseError(e.error, this.translate.currentLang,this.translate.instant('MessageService.PalletStock.CreatePalletStockError') )  })

        }

      })
    }
  }

  getFridgeStorages()
  {
    this._fridgeStorageService.getAllAvailable().subscribe({
      next: (v) => {
         this.fridgeStorages = v
      },
      error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.FridgeStorage.ManyRetrieveError') });
        }
    })
  }

  updateStock()
  {
    this.submitStockFile = true;
    if(this.stockFormGroup.valid && this.selectStockId)
    {
      this.loading = true;

      let newStock: UpdatePalletStockRequest = {
        file: this.stockFile,
        formatPalletStockId: this.stockFormGroup.controls['formatPalletStockId'].value,
        stockName: this.stockFormGroup.controls['stockName'].value,
        stockId: this.selectStockId,
        fridgeStorageId: this.stockFormGroup.controls['fridgeStorageId'].value
      }

      this._palletStockService.updatePalletStock(newStock).subscribe({
        next: (v) => {
            this._messageService.add({ severity: 'success',
            summary: this.translate.instant('MessageService.Summary.SuccessAction'),
            detail: this.translate.instant('MessageService.PalletStock.UpdatePalletStockSuccess') })
            this.loading = false
            this.visibleCreateStock = false;
            this.isEdit = false;
            this.getLoadProcesses();
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.UpdatePalletStockError') })
        }

      })
    }
  }

  ngOnInit(): void {
    this.profile = this._authService.getUser();
    this.getFormats()
    this.getStocks()
    this.getFridgeStorages()
    this.getLoadProcesses();
    // this.startActiveProcessesPolling();
    //this.getColumns()
  }

  ngOnDestroy(): void {
    // this.stopActiveProcessesPolling();
  }

  startActiveProcessesPolling() {
    if (this.isPollingProcesses) return;

    this.isPollingProcesses = true;

    const loadProcesses = () => {
      this._palletStockService
        .getPalletStockImportProcesses()
        .subscribe({
          next: (response) => {
            this.activeImportProcesses = response;

            this.pollingTimeout = setTimeout(
              loadProcesses,
              20000
            );
          },
          error: (error) => {
            console.log(error);

            //Reintento controlado
            this.pollingTimeout = setTimeout(
              loadProcesses,
              8000
            );
          }
        });
    };

    loadProcesses();
  }

  getLoadProcesses()
  {
    this.loadingProcesses = true;
    this._palletStockService
      .getPalletStockImportProcesses()
      .subscribe({
        next: (response) => {
          this.activeImportProcesses = response;
          this.loadingProcesses = false;

        },
        error: (error) => {
          console.log(error);
          this.loadingProcesses = false;

        }
      });
  }

  updateData()
  {
    this.getLoadProcesses();
    this.getStocks();
  }

  stopActiveProcessesPolling() {
    this.isPollingProcesses = false;

    if (this.pollingTimeout) {
      clearTimeout(this.pollingTimeout);
    }
  }

  getFormats(loadLast: boolean = false)
  {

    this.loading = true;
    this._palletStockService.getFormatPalletStock().subscribe({
      next: (v) => {
        this.formatPalletStock = v
        if(loadLast && this.formatPalletStock.length > 0)
        {
          console.log(this.formatPalletStock[this.formatPalletStock.length - 1].id);
          this.stockFormGroup.controls['formatPalletStockId'].setValue(
            this.formatPalletStock[this.formatPalletStock.length - 1].id
             )
        }
        // else
        // {
        //   console.log(this.formatPalletStock.length);
        //   if(this.formatPalletStock.length > 0)
        //   {
        //     this.stockFormGroup.controls['formatPalletStockId'].setValue(
        //       this.formatPalletStock[0].id
        //     )
        //   }
        // }
        this.loading = false;
      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetStockError') })
      }
    })
  }

  deleteStock(stock: Stock)
  {

    this._confirmationService.confirm({
      message: this.translate.instant('MessageService.PalletStock.DeleteStockConfirm', {value: stock.name}),
      header: this.translate.instant('MessageService.PalletStock.DeleteStockHeader'),
      icon: 'pi pi-trash',
      acceptLabel: this.translate.instant('MessageService.FridgeStorage.DeleteButton'),
      rejectLabel: this.translate.instant('MessageService.FridgeStorage.CancelButton'),
      acceptIcon: 'pi',
      rejectIcon: 'pi',
      accept: () => {
        this.loading = true;
        this._palletStockService.deleteStock(stock.id).subscribe({
          next: (v) => {
              this._messageService.add({ severity: 'success',
              summary: this.translate.instant('MessageService.Summary.FailedAction'),
              detail: this.translate.instant('MessageService.PalletStock.DeleteStockSuccess') })

              this.loading = false;

              this.getStocks();
          },
          error: (e) => {
              this._messageService.add({ severity: 'error',
                summary:
                this.translate.instant('MessageService.Summary.FailedAction'),
                detail: ErrorMessageUtil.getResponseError(e.error,
                  this.translate.currentLang,
                  this.translate.instant('MessageService.PalletStock.DeleteStockError') )  });
              this.loading = false
          }
        })
      },
      reject: (type: any) => {
        switch (type) {
            case ConfirmEventType.REJECT:
                break;
            case ConfirmEventType.CANCEL:
                break;
        }
      }
    })

  }

  getStocks(pageSize: number = this.pageSize, pageNumber: number = 1)
  {
    this.loading = true;
    const profile = this._authService.getUser();

    this._palletStockService.getStockPaged(pageNumber, pageSize).subscribe({
      next: (v) => {
        this.stocks = v.items.map(stock => ({
          ...stock,
          menu: [
            { label: this.translate.instant('UserPalletStock.EditStock'), command: () => this.onEditStock(stock) },
            { label: this.translate.instant('UserPalletStock.Rollback'), command: () => this.onRollbackVersion(stock),
              disabled: stock.activeVersion && stock.activeVersion < 2 ? true : false},
            { label: this.translate.instant('UserPalletStock.ViewStockStats'), command: () => this.onViewStats(stock) },
            { label: this.translate.instant('UserPalletStock.DeleteStock'), command: () => this.deleteStock(stock) },
          ]
        }))

        this.totalCount = v.totalCount;
        this.loading = false;
      },
      error: (e) => {
        console.log(e)
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetFormatError') })
      }
    })
  }

  showStockAlert(stockId: number)
  {
    this.selectAlertStockId = stockId
    this.getStockAlert();
  }

  getStockAlert()
  {
    if(this.selectAlertStockId)
    {
      this.loadingAlert = true;
      this._stockAlertService.getStockAlert(this.selectAlertStockId).subscribe({
        next: (v) => {
          this.stockAlerts = v;
          this.visibleAlerts = true;
          this.loadingAlert = false;
        },
        error: (e) => {
          console.log(e)
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.GetStockAlertError') })
            this.loadingAlert = false;
        }
      })
    }

  }

  updateReviewed(stockAlertGuid: string, event: any)
  {
    this.loadingAlert = true;
    this._stockAlertService.update(stockAlertGuid, event.checked).subscribe({
      next: (v) => {
          this._messageService.add({ severity: 'success',
          summary: this.translate.instant('MessageService.Summary.SuccessAction'),
          detail: this.translate.instant('MessageService.PalletStock.UpdateReviewSuccess') })
        this.loadingAlert = false;
        this.getStockAlert()
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.UpdateReviewError') })
          this.loadingAlert = false;
          this.getStockAlert()
      }
    })
  }

  getStocksPaged(event: any)
  {
      const pageNumber = Math.floor(event.first / event.rows) + 1;
      const pageSize = event.rows;

      this.getStocks(pageSize, pageNumber);
  }

  getErrorMessage(formGroup: FormGroup, fieldName: string): string {
    return ErrorMessageUtil.getErrorMessage(formGroup, this.translate, fieldName)
  }

  onSelectDocumentFile(event: any) {
    this.stockFile = event.files[0]
  }

  onClearDocumentFile(event: any) {
    this.stockFile = null
  }

  loadFormatFromExcel()
  {

    if(this.stockFile)
    {
      const reader: FileReader = new FileReader();

      reader.onload = (e: ProgressEvent<FileReader>) => {
      const arrayBuffer = e.target?.result as ArrayBuffer;
      const workbook = XLSX.read(arrayBuffer, { type: 'array' });

      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];

      const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      this.headers = sheetData[0] as string[];
    };

      reader.readAsArrayBuffer(this.stockFile);
      this.visibleCreateFormatPalletStock = true;
    }
    else {
      this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.PalletStock.NoFileSelectedWarning') })
    }

  }

  onCancelCreateFormat()
  {
    this.visibleCreateFormatPalletStock = false
    this.headers = []
  }

  onSaveFormat()
  {
    this.getFormats();
    this.headers = []
    this.visibleCreateFormatPalletStock = false
  }

  @ViewChild('palletStockTable') dt!: Table;
  getPalletStock(pageSize: number = 10, pageNumber: number = 1)
  {
      if(this.selectStockId)
      {
        this.loadingPalleStock = true;
        var request: PalletStockFilterRequest = {
          pageSize,
          pageNumber,
          stockId: this.selectStockId,
          containerFilter: this.filter.containerFilter,
          speciesSizeFilter: this.filter.speciesSizeFilter,
          statusFilter: this.filter.statusFilter,
          growerFilter: this.filter.growerFilter,
          speciesFilter: this.filter.speciesFilter,
          varietyFilter: this.filter.varietyFilter,
          programNameFilter: this.filter.programNameFilter

        }
        //this.configFilter({})
        this._palletStockService.getPalletStockPaged(request).subscribe({
          next: (v) => {
            this.palletStock = v.items;
            console.log('entra');
            this.totalCountPalletStock = v.totalCount;
            this.loadingPalleStock = false;
          },
          error: (e) => {
            this.loadingPalleStock = false
            this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.PalletStock.GetPalletStockError') })
          },
          complete: () => {
            this.loadingPalleStock = false;
          }
        })
      }
  }


  getPalletStockPaged(event: any)
  {
    const pageNumber = Math.floor(event.first / event.rows) + 1;
    const pageSize = event.rows;
    if (this.lastPage == event.first && this.lastSize == event.rows) {
      return;
    }
    this.lastPage = event.first || 0;
    this.lastSize =  pageSize;

    this.getPalletStock(pageSize, pageNumber);

  }

  getColumns()
  {
    this.loading = true;
    this._palletStockService.getColumns().subscribe({
      next: (v) => {
        this.stockColumns = v;
        this.loading = false;
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.PalletStock.GetStockColumnsError') })
      }
    })
  }

  onViewStock(stock: Stock)
  {
    this.selectStockId = stock.id;
    this.selectedStockName = stock.name;
    this.selectedStockCreated = stock.created;
    this.selectedLastFormatId = stock.lastFormatId;
    this.getColumnsByStock(stock.id)
  }

  getColumnsByStock(stockId: number)
  {
    this._palletStockService.getStockFormatColumns(stockId).subscribe({
      next: (v) => {
        this.stockColumns = v;
        this.getPalletStock()
        this.loading = false;
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.PalletStock.GetStockColumnsError') })
      }
    })

    this.visiblePalletStock = true;
  }

  onEditStock(stock: Stock)
  {
    this.selectStockId = stock.id;
    this.selectedStockName = stock.name;
    this.selectedStockCreated = stock.created;
    this.selectedLastFormatId = stock.lastFormatId;
    this.stockFormGroup.controls['stockName'].setValue(stock.name)
    this.stockFormGroup.controls['fridgeStorageId'].setValue(stock.fridgeStorageId)

    //this.stockFormGroup.controls['formatPalletStockId'].setValue(stock.lastFormatId ?? null)
    this.isEdit = true
    this.visibleCreateStock = true
  }

  onVisibleCreateStock()
  {
    this.stockFile = null;
    this.visibleCreateStock = true;
    this.stockFormGroup.controls['stockName'].setValue('')
    this.stockFormGroup.controls['fridgeStorageId'].setValue(null)
    this.isEdit = false
  }

  onVisibleCreateFormatPalletStock() {
    this.stockFile = null;
    this.visibleCreateFormatPalletStock = true
  }

  configFilter(event: any)
  {
    this.filter = {... event}
    this.getPalletStock()
  }

  onCloseFileFormat() {
    this.stockFile = null;
    this.selectStockId = undefined;
    this.selectedStockName = undefined;
    this.selectedStockCreated = undefined;
    this.selectedLastFormatId = undefined;
    this.stockFormGroup.reset();
    this.visibleCreateStock = false;
  }

  showQuarterConfig(stock: Stock){
    this.selectStockId = stock.id;
    this.visibleQuarterNameConfig = true;

  }

  onViewStats(stock: Stock)
  {
    this.loading = true;
    this._palletStockService.getStockStats(stock.id).subscribe({
      next: (v) => {
      this.selectStock = v;
      this.visibleStats = true;
        this.loading = false;
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.PalletStock.GetStockColumnsError') })
      }
    })

  }

  showProgramFromStock(stock: Stock)
  {
    this.selectStock = stock;
    this.visibleProgramFromStock = true;
  }

  onViewRules(stock: Stock){
      this.selectStock = stock;
      this.visibleRule = true;
  }

  onCancelCreateFromStock(): void {
    this.visibleProgramFromStock = false;
  }


  onRollbackVersion(stock: Stock)
  {
    this.loading = true;
    this._confirmationService.confirm({
      message: this.translate.instant('MessageService.PalletStock.RollbackConfirm', {value: stock.name}),
      header: this.translate.instant('MessageService.PalletStock.RollbackHeader'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translate.instant('MessageService.PalletStock.RollbackButton'),
      rejectLabel: this.translate.instant('MessageService.FridgeStorage.CancelButton'),
      acceptIcon: 'pi',
      rejectIcon: 'pi',
      accept: () => {
        if(stock.activeVersion)
        {
          this._palletStockService.rollBackVersion(stock.id, stock.activeVersion).subscribe({
            next: (v) => {
                this._messageService.add({ severity: 'success',
                summary: this.translate.instant('MessageService.Summary.SuccessAction'),
                detail: this.translate.instant('MessageService.PalletStock.RollbackSuccess') })
                this.loading = false;
                this.getStocks();
            },
            error: (e) => {
                this._messageService.add({ severity: 'error',
                  summary: this.translate.instant('MessageService.Summary.FailedAction'),
                  detail: ErrorMessageUtil.getResponseError(e.error,
                    this.translate.currentLang,
                    this.translate.instant('MessageService.PalletStock.RollbackError') )  });
                this.loading = false
            }
          })
        }
      },
      reject: (type: any) => {
        switch (type) {
            case ConfirmEventType.REJECT:
                this.loading = false;
                break;
            case ConfirmEventType.CANCEL:
                this.loading = false;
                break;
        }
      }
    })

     this.loading = false

  }

}
